import "./input.css";
import { Input } from './input';
export default Input;